import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import clsx from 'clsx';

// copied from https://gist.github.com/6174/6062387?permalink_comment_id=3390777#gistcomment-3390777
const fakeUuid = (length) => [...Array(length)].map(() => (Math.floor(Math.random() * 36)).toString(36)).join('');

export default function BlogPostTable(blok) {
  const { table } = blok;

  const styles = clsx(
    'blok-blogpost-table',
    'overflow-x-scroll -ml-4 px-4 md:mx-0 md:px-0 w-screen md:w-auto',
  );

  return (
    <div {...storyblokEditable(blok)} className={styles}>
      <table>
        {table?.thead?.find((th) => th.value !== '') && (
          <thead>
            <tr>
              {table?.thead?.map((th) => (
                <th key={fakeUuid(10)}>{th.value}</th>
              ))}
            </tr>
          </thead>
        )}
        {table?.tbody?.find((tr) => tr.body.find((td) => td.value !== '')) && (
          <tbody>
              {table?.tbody?.map((tr) => (
                <tr key={fakeUuid(10)}>
                  {tr?.body?.map((td) => (
                    <td key={fakeUuid(10)}>{td.value}</td>
                  ))}
                </tr>
              ))}
          </tbody>
        )}
      </table>
    </div>
  );
}
